import React from "react";

import ForgetPasswordForm from "../component/Register/ForgetPasswordForm";

const ForgetPasswordPage = () => {


  return (
    <section className="text-gray-900 transition-colors bg-bg-light-primary dark:bg-bg-dark-primary dark:text-gray-100">
      <ForgetPasswordForm />
    </section>
  );
};

export default ForgetPasswordPage;
